<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @submit="submit" :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '../components/page/table.vue'
  import FORM from '../components/page/form.vue'
  import UPDATE from '../components/page/update.vue'
  import URL from '@/views/mis/util/url'
  import Qs from 'qs'
  import axios from 'axios'
  let typeList={"1":"dfre","2":"CFVN","3":"资讯包","4":"马甲包","5":"TC","6":"股票包","7":"多业务","8":"适用用户","9":"转换状态","10":"激活状态","11":"用户等级","12":"适用平台", "13":"有效期", "14":"广告位置","15":"快应用", "16":"广告渠道"};
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      checkbox(row){
        this.deleteIds = row.map(key => key.id).join(",");
      },
      /*表格按钮点击事件*/
      bthClick (clickName, row) {if(clickName =="delete"){
          this.$confirm(window.$t("common.ifDelete"), window.$t("common.tip"), {
              distinguishCancelAndClose: true,
              confirmButtonText: window.$t("common.ok"),
              cancelButtonText: window.$t("common.canceld")
          }).then(() => {
              this.$axios.get(URL.advertising.configDel+"?id="+row.id).then(res=> {
                  if (res.code == 0) {
                      this.$message.success("suc");
                      this.$refs.childTable.defaultGetData(this.queryData);
                  }
              });
          })

      }else  if (clickName == "update" ){
          this.$refs.childUpdate.open(row);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName || window.$t("common.search") == clickName){
          this.queryData = data;
          this.$refs.childTable.defaultQueryData(data);
        }else if("新增" == clickName || window.$t("common.addNew") == clickName){
          this.$refs.childUpdate.open();
        }
      },
      /*新增或跟提交数据触发事件*/
      submit(model){
        //根据是否包含id更新还是添加
        this.dataChanage((model.id!=undefined && model.id!=null && model.id!='') ? URL.advertising.configEdit:URL.advertising.configSave,model,res => {
          if (res.code == 0){
          this.$refs.childUpdate.close();
          this.$message.success("suc");
          this.$refs.childTable.defaultGetData(this.queryData);
        }else{

        }
      })
      },
      dataChanage(url,option,suc,fail){
        this.$axios.post(url, Qs.stringify(option || {})).then(res => {

        if(suc && (typeof suc == 'function')) suc(res);
      }).catch(res => {
          if(fail && (typeof fail == 'function')) fail(res);
      })
      }
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*新增或更新*/
        updateData:{
          cols:[
                          { title: '', field: 'id',hidden:true},
                          { title: window.$t("mis.advertising.key"), field: 'key'},
                          { title: window.$t("mis.advertising.value"), field: 'value'},
                          { title: window.$t("mis.advertising.type"), field: 'type',type:2,optionList:typeList,isNumber:true},
                      ]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
                          { title:  window.$t("mis.advertising.type"), field: 'type',type:2,optionList:typeList},
                          {click:window.$t("common.search"),auth:"sys:advertisingConfig:view"},
                          {click:window.$t("common.addNew"),auth:"sys:advertisingConfig:save"}
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.advertising.configQuery, //请求路径和参数
          selection: true,
          sequence: true,
          cols: [

                          { title: window.$t("mis.advertising.key"), field: 'key'},
                          { title: window.$t("mis.advertising.value"), field: 'value'},
                          { title: window.$t("mis.advertising.type"), field: 'type',render:(data)=>{
                              return typeList[data];
                          }},
                          { title: window.$t("mis.advertising.createTime"), field: 'createDate'},
              {title:window.$t("common.handle"),btnClick:[{name:window.$t("common.delete"),click:"delete",type:"primary",icon:"el-icon-delete",auth:"sys:advertisingConfig:delete"},{name:window.$t("common.edit"),click:"update",type:"primary",icon: "el-icon-edit",auth:"sys:advertisingConfig:edit"}]},

          ]
        }
      }
    }
  }
</script>
